import React from 'react'
import classnames from 'classnames'
import {
  Wrapper as AmbWrapper, Button as AmbButton,
  Menu as AmbMenu, MenuItem as AmbMenuItem }
  from 'react-aria-menubutton'

const SizeToModifierClass = {
  "small": "AriaMenuButton--small",
  "large": "AriaMenuButton--large"
}

/*
  SimpleSelect
  A wrapper for https://github.com/davidtheclark/react-aria-menubutton

  Props:
  onSelection   (Function) called when select item is selected. Parameters: value, SyntheticEvent
  options       (object) object with "value" and "text" keys to fill select box
  selectedValue (any) The "value" field of the selected item
  displayFormat (Function) A function that returns the selected item and renders it. Default is _.identity
  style         (object) css style
  className     (string) css class
  size          (string) one of SizeToModifierClass keys
  disabled      (bool) Whether disabled or not
*/
function SimpleSelect({ onSelection, options, selectedValue, displayFormat, itemFormat, style, size, className, disabled }) {
  let selected
  if (!itemFormat) {
    itemFormat = _.identity
  }
  const items = options.map(({ value, text }) => {
    if (selectedValue === value) selected = value
    return (
      <AmbMenuItem
        key={ value }
        value={ value }
        text={ text || value }
      >
        {itemFormat(text || value) }
      </AmbMenuItem>
    )
  })
  if (!displayFormat) {
    displayFormat = _.identity
  }
  return (
    <AmbWrapper
      className={ classnames("AriaMenuButton", SizeToModifierClass[size], className) }
      onSelection={ onSelection }
      style={ style }
    >
      <AmbButton disabled={ disabled || false }
        className={classnames({'AriaMenuButton--disabled': disabled})}>
        <div className="content">
          { displayFormat(selectedValue) }
        </div>
      </AmbButton>
      <AmbMenu>
        { items }
      </AmbMenu>
    </AmbWrapper>
  )
}

export default SimpleSelect



// WEBPACK FOOTER //
// ./src/scripts/components/shared/SimpleSelect/index.js